import React from 'react';
import { motion } from 'framer-motion';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
  title: 'Enterprise Microservices Platform',
  description: 'Scalable microservices architecture built with Java 21 and Spring Boot, including service discovery with Eureka, secure authentication with Keycloak (SSO), and CI/CD automation using Azure DevOps.',
  image: '🏗️',
  technologies: ['Java 21', 'Spring Boot', 'Spring Cloud', 'Eureka', 'Keycloak', 'Docker', 'Azure DevOps'],
  featured: true
},
{
  title: 'Secure REST API with JWT & SSO',
  description: 'Implementation of secure RESTful services with JWT-based authentication and Single Sign-On (SSO). Includes role-based authorization and interactive documentation with Swagger.',
  image: '🔐',
  technologies: ['Spring Security', 'JWT', 'Keycloak', 'Swagger', 'PostgreSQL'],
  featured: true
},
{
  title: 'Full Stack Business Application',
  description: 'Full stack web application built with Spring Boot backend and React/Next.js frontend. Features responsive UI with Tailwind CSS and secure HTTPS integration.',
  image: '💻',
  technologies: ['Java', 'Spring Boot', 'React', 'Next.js', 'Tailwind', 'PostgreSQL'],
  featured: true
},
{
  title: 'Batch Processing System',
  description: 'High-performance batch processing system using Spring Batch for large-scale data handling and optimization in enterprise environments.',
  image: '⚙️',
  technologies: ['Java 11', 'Spring Batch', 'Oracle', 'HANA', 'MySQL'],
  featured: false
},
{
  title: 'Automated Reporting with JasperReports',
  description: 'Dynamic reporting system integrating JasperReports for automated document generation and structured data mapping.',
  image: '📊',
  technologies: ['JasperReports', 'Spring Boot', 'PostgreSQL', 'REST API'],
  featured: false
},
{
  title: 'Database Migration & Integration Project',
  description: 'Database migration and ETL processes using Talend Open Studio, improving relational schema structure and system integration workflows.',
  image: '🗄️',
  technologies: ['Talend', 'PostgreSQL', 'MySQL', 'SQL', 'Data Migration'],
  featured: false
}

  ];

  return (
    <section id="projects" className="section projects">
      <div className="container">
        <motion.h2 
          className="section-title gradient-text"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Featured Projects
        </motion.h2>

        <div className="projects-grid">
          {projects.map((project, idx) => (
            <motion.div
              key={idx}
              className={`project-card ${project.featured ? 'featured' : ''}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1, duration: 0.5 }}
              whileHover={{ y: -10 }}
            >
              {project.featured && (
                <div className="featured-badge">Destacado</div>
              )}
              
              <div className="project-image">
                <span className="project-emoji">{project.image}</span>
              </div>

              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>

                <div className="project-tech">
                  {project.technologies.map((tech, techIdx) => (
                    <span key={techIdx} className="tech-badge">{tech}</span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
